import { toNote } from '@/lib/link'
import { tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Content from './Content'

export default function ForumThreadPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const title = useMemo(() => event.tags.find(tagNameEquals('title'))?.[1], [event])

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Thread')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()}>
        {title ? (
          <span className="italic pr-0.5">{title}</span>
        ) : (
          <Content event={event} className="italic pr-0.5" />
        )}
      </a>
    </div>
  )
}
